var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['moz-search-button', _vm.btnClasses],attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('span',{staticClass:"icon-search"},[_c('icon-search')],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }